import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import 'babel-polyfill';

import OrdinationApp from '../ordination/ordination_app';
import 'react-select/dist/react-select.css';
import "../../assets/stylesheets/confirmation.css"
import { setTokenForAxios } from './helpers/form_support';

document.addEventListener("DOMContentLoaded", () => {
  setTokenForAxios();

  ReactDOM.render(
    <BrowserRouter basename="/ordination-application">
      <OrdinationApp/>
    </BrowserRouter>,
    document.getElementById('ordination')
  );
});
